import { render, staticRenderFns } from "./taskSkill.vue?vue&type=template&id=5d9364be&scoped=true&"
import script from "./taskSkill.vue?vue&type=script&lang=js&"
export * from "./taskSkill.vue?vue&type=script&lang=js&"
import style0 from "./taskSkill.vue?vue&type=style&index=0&id=5d9364be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9364be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d9364be')) {
      api.createRecord('5d9364be', component.options)
    } else {
      api.reload('5d9364be', component.options)
    }
    module.hot.accept("./taskSkill.vue?vue&type=template&id=5d9364be&scoped=true&", function () {
      api.rerender('5d9364be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/robot/task/taskSkill.vue"
export default component.exports